module.exports = __webpack_public_path__ + "img/blackboard.c8b38491.svg";